import { useSelector } from "../../../redux/hooks";
import { useEffect, useMemo } from "react";
import { ICol } from "../../../interfaces";
import Cell from "../../../generator/Cell/Cell";
import { StyledGuernseyTr } from "./Guernsey.styled";
import { getColValue } from "../../../pages/Reports/Report/Report.utils";

interface Props {
  tag: string | undefined;
  rowIndex: number | undefined;
  summary?: boolean;
  lbeid?: string;
}
const GuernseyChildInput = ({ tag, rowIndex, summary, lbeid }: Props) => {
  const { guernseyData } = useSelector(state => state.generatorFeaturesSlice);
  const { uppercase } = useSelector(state => state.preferencesSlice);
  const cols = useMemo(() => {
    if (
      !tag ||
      !guernseyData ||
      rowIndex === undefined ||
      !guernseyData[rowIndex]
    )
      return {};

    const index = tag.split("-")[1];
    return guernseyData[rowIndex][index];
  }, [guernseyData, tag]);
  return (
    <table>
      {cols &&
        Object.entries(cols).map(([key, col]) => (
          <StyledGuernseyTr key={key}>
            <td
              className="bottom-border"
              style={
                summary && (col.unit === "large/text" || col.unit === "text")
                  ? {
                      maxWidth: "400px",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }
                  : undefined
              }>
              {summary ? (
                getColValue({ ...col, hideSig: true }, [], "", null, uppercase)
              ) : (
                <Cell
                  {...(col as any)}
                  uuid={key}
                  unitType={col.unit}
                  value={col.value ?? ""}
                  hideSig
                />
              )}
            </td>
          </StyledGuernseyTr>
        ))}
    </table>
  );
};
export default GuernseyChildInput;
